import { ProductTypeEnum } from '@ecoflow/ef-device-core/src/constants';

/**
 * @desc 应用名
 */
export enum DeviceUserApp {
    JT = 'ef-device-user-jt',
    PD = 'ef-device-user-pd',
}

/**
 * @desc 产品映射应用名
 */
export const APP_NAME_MAP: { [key: string]: string } = {
    [ProductTypeEnum.JT303]: DeviceUserApp.JT,
    [ProductTypeEnum.JT321]: DeviceUserApp.JT,
    [ProductTypeEnum.DC303]: DeviceUserApp.JT,
    [ProductTypeEnum.PD303]: DeviceUserApp.PD,
};
